import * as React from "react";
type Props = {
  className?: string,
};
function SvgArrowRightTurn({ className }: Props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-ArrowRightTurn"
      className={className}
    >
      <path
        d="M6.31592 4V15.0667H18.9475"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9808 19.9608L19.861 15.0176L12.9058 10.0206"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgArrowRightTurn;
